'use client'

import { useEffect } from 'react'
import { PageViewed, useTrackFormStepViewed } from '@nwwp/segment-analytics'
import { cn } from '@nwwp/ui-shadcn'
import { TrackedLink } from '~/components/TrackedLink'

export function DisqualifiedView() {
  const trackFormStepViewed = useTrackFormStepViewed()

  useEffect(() => {
    trackFormStepViewed({ step: 'disqualified', type: 'terminal', formName: 'schedule_form' })
  }, [trackFormStepViewed])

  return (
    <PageViewed pageName="Schedule Form Disqualified">
      <div className="w-full max-w-lg rounded-2xl bg-white p-8">
        {/* Alert icon */}
        <div className="mb-6 flex justify-center">
          <div className="flex size-14 items-center justify-center rounded-full border border-smoke">
            <span className="text-title-xs font-light text-neutral-darker" aria-hidden="true">
              !
            </span>
          </div>
        </div>

        <p className="text-title-xs mb-3 text-center font-bold text-gray-dark">
          We&rsquo;re not the right fit right now
        </p>

        <p className="mb-6 text-center text-body-sm text-neutral-darker">
          Thank you for your interest in NerdWallet Wealth Partners. Based on the information you provided, our advisory
          services aren&rsquo;t the best match at this time.
        </p>

        <hr className="mb-6 border-smoke" />

        <p className="mb-3 text-subtitle font-bold text-neutral-darker uppercase">In the meantime</p>

        <TrackedLink
          href="https://nerdwalletwealthpartners.com/tools"
          target="_blank"
          rel="noopener noreferrer"
          segmentElement="Disqualified CTA"
          className={cn(
            'group flex items-center gap-4 rounded-xl border border-smoke bg-frost p-4 transition-colors',
            'hover:border-green hover:bg-green-surface'
          )}
        >
          <div className="flex size-10 flex-shrink-0 items-center justify-center rounded-full bg-green">
            <span className="text-body font-bold text-white" aria-hidden="true">
              ?
            </span>
          </div>

          <div className="flex-1">
            <p className="text-body-sm font-bold text-gray-dark">Explore our free guides and tools</p>
            <p className="text-body-sm text-neutral-darker">
              Use our calculators and resources to help you make informed financial decisions.
            </p>
          </div>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="flex-shrink-0 text-neutral-dark transition-colors group-hover:text-green"
            aria-hidden="true"
          >
            <path d="M9 18l6-6-6-6" />
          </svg>
        </TrackedLink>
      </div>
    </PageViewed>
  )
}
